module.exports = __webpack_public_path__ + "static/media/bear_phone_new.fcb037b5.png";